/**
 * 401 을 받았을 때 비워야 할 저장소 키.
 *
 * 관리자 화면은 admin_token·admin_user 를, 나머지는 token·user 를 쓴다.
 * 어느 쪽을 지울지 한 곳에서 정해, 인터셉터와 adminAuth 가 서로 다른
 * 범위를 지우는 일이 없게 한다.
 */

const USER_KEYS = ['token', 'user'] as const
const ADMIN_KEYS = ['admin_token', 'admin_user'] as const

export const ADMIN_HOSTNAME = 'admin.shorty.kr'

/** 해당 호스트에서 세션으로 간주하는 키 목록 */
export function sessionKeysFor(hostname?: string | null): string[] {
  return hostname === ADMIN_HOSTNAME
    ? [...USER_KEYS, ...ADMIN_KEYS]
    : [...USER_KEYS]
}

/**
 * 세션 키만 지운다. 언어·테마 같은 값은 남긴다.
 * 사생활 보호 모드처럼 저장소를 쓸 수 없는 환경에서도 던지지 않는다.
 */
export function clearStoredSession(hostname?: string | null): void {
  for (const key of sessionKeysFor(hostname)) {
    try {
      localStorage.removeItem(key)
    } catch {
      // 저장소를 쓸 수 없는 환경. 지울 것이 없으므로 계속 진행한다.
    }
  }
}

export default { sessionKeysFor, clearStoredSession, ADMIN_HOSTNAME }
